export default class LanguagePicker {
    init() {
        this.languagePicker = document.querySelectorAll(".js-language-picker");

        this.event();
    }

    event() {
        if (this.languagePicker.length > 0) {
            this.languagePicker.forEach((picker) => {
                picker.addEventListener("change", (event) => {
                    event.preventDefault();

                    let selectedLanguage = event.target;
                    if (selectedLanguage) {
                        window.location.href = selectedLanguage.value;
                    }
                });
            });
        }
    }
}
